/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';

import Args from 'solis/claude/action/args';

import useTargetZone from 'solis/claude/action/target.zone';
import useSourceColony from 'solis/claude/action/source.colony';

import Time from 'solis/time';


// The action context for a board pane: the board in view (by route id), the operating
// source colony, the selected target zone, and the current account.
export default () =>
{
  const route        = use(Route);
  const galaxy       = use(Galaxy);
  const board        = galaxy.getBoard(route.getArg('id'));
  const account      = galaxy.getCurrentAccount();
  const zone         = useTargetZone(board, Args.BoardZone);
  const sourceColony = useSourceColony(board, account);
  const now          = use(Time);

  return { board, sourceColony, zone, account, now };
};
